import SearchBar from '../search/SearchBar';
import CheckBetButton from './CheckBetButton';
import MyBetsButton from './MyBetsButton';
import NavButtonsContainer from './NavButtonsContainer';

export default function Topbar() {
    return (
        <div className="c_3">
            <div className="c_3_1">
                <SearchBar />
            </div>
            <NavButtonsContainer />
            <div className="c_3_3">
                <MyBetsButton />
                <CheckBetButton />
            </div>
        </div>
    );
}
